export const onDeleteTitle = (page: string, title: any) => {
    return {
      type: 'onDeleteTitle',
      title: title,
      pageNumber: page
    }
}